import { z } from 'zod';
import { getShortCourseDtoSchema } from '../getShortCourseDtoSchema';

export const coursesControllerGetShortCoursesCreatedByMe200Schema = z.array(
  z.lazy(() => getShortCourseDtoSchema),
);

export const coursesControllerGetShortCoursesCreatedByMe401Schema = z.object({
  statusCode: z.enum(['401']),
  message: z.string(),
  type: z.enum(['Authentication']),
  details: z.object({
    reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
  }),
});

export const coursesControllerGetShortCoursesCreatedByMe403Schema = z.object({
  statusCode: z.enum(['403']),
  message: z.string(),
  type: z.enum(['Authorization']),
  details: z.object({ reason: z.enum(['InsufficientScope']) }),
});

export const coursesControllerGetShortCoursesCreatedByMeQueryResponseSchema =
  z.array(z.lazy(() => getShortCourseDtoSchema));
